exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".uNYkF{padding-right:10px;padding-left:10px;border-bottom:1px #fff}.uNYkF>div{margin:0}.uNYkF input{border:1px solid #b4b4b4}._1Zxej{margin-right:10px;padding:6.5px 12px}", ""]);

// exports
exports.locals = {
	"teal": "#00dcb2",
	"grey": "#b4b4b4",
	"orange": "#ff4e32",
	"sick": "#673ab7",
	"vacation": "#cddc39",
	"holiday": "#4caf50",
	"notificationUserField": "uNYkF",
	"trash": "_1Zxej"
};